import React from 'react';

import { isEmpty } from 'lodash';
import { BreadcrumbWrapper } from 'src/components/Breadcrumb';
import { addDealBreadcrumbItems } from 'src/constants/addDeal';
import { AddDealContext } from 'src/contexts/addDealContext';

export const AddDealBreadcrumb = () => {
    const { selectedVendors, setIsCancelModalOpen } = React.useContext(AddDealContext);
    const handleBreadcrumbRedirect = () => {
        if (!isEmpty(selectedVendors)) {
            setIsCancelModalOpen(true);
            return true;
        } else {
            return false;
        }
    };

    return (
        <BreadcrumbWrapper
            breadcrumbItems={addDealBreadcrumbItems}
            handleRedirect={handleBreadcrumbRedirect}
            showBottomBorder={true}
        />
    );
};
